module.exports = __webpack_public_path__ + "assets/devices/MCM-140-f5011fa19f36a2a0ec68fda1c92a8de2.svg";